/* ============================================================
   KÉNOS — Buy panel + page interactions
   - Pack selector + qty stepper + savings recompute
   - FAQ accordion
   - Countdown to midnight
   - Scroll reveal
   - Mobile sticky CTA
   - Cart redirect with Meta Pixel events

   Redondeo de precios (fix ago-2026): el precio con descuento se calcula
   redondeando el precio UNITARIO al peso y recien ahi multiplicando por la
   cantidad, igual que Shopify. Antes se redondeaba el total de la linea, lo
   que en el tier de 5 frascos mostraba $64.968 mientras el checkout cobraba
   $64.970 (Shopify usa discounted_price unitario $12.994).
   ============================================================ */
(function () {
  'use strict';

  if (window.__kenosBooted) return;
  window.__kenosBooted = true;

  // ---- Helpers --------------------------------------------------
  var fmtCLP = function (n) {
    return '$' + Math.round(n).toLocaleString('es-CL');
  };

  // Precio con descuento de volumen, replicando el redondeo de Shopify:
  // redondea el UNITARIO al peso y despues multiplica por la cantidad.
  var tierPrice = function (unitPrice, qty, pct) {
    if (!pct) return Math.round(unitPrice) * qty;
    return Math.round(unitPrice * (100 - pct) / 100) * qty;
  };

  var uuidv4 = function () {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  var firePixel = function (event, params, eventId) {
    if (typeof window.fbq !== 'function') return;
    try {
      window.fbq('track', event, params || {}, { eventID: eventId });
    } catch (e) {
      /* no-op */
    }
  };

  // ---- Buy panel ------------------------------------------------
  // The quantity stepper is the single source of truth (real number of frascos).
  // Pack cards are presets: the card whose qty === current quantity is highlighted;
  // if no card matches (e.g. 4) none is highlighted. The discount tier applied is the
  // highest pack whose qty <= current quantity (4 -> KENOS3, 6 -> KENOS5), so the code
  // sent to the cart always matches the real quantity and the checkout total.
  var initBuyPanel = function (root) {
    var packs = Array.prototype.slice.call(root.querySelectorAll('.k-pack-card'));
    if (!packs.length) return;

    var qtyValEl = root.querySelector('[data-kenos-qty-val]');
    var qtyMinusBtn = root.querySelector('[data-kenos-qty-minus]');
    var qtyPlusBtn = root.querySelector('[data-kenos-qty-plus]');
    var ctaBtn = root.querySelector('[data-kenos-add-to-cart]');
    var ctaPrice = root.querySelector('[data-kenos-cta-price]');
    var ctaWas = root.querySelector('[data-kenos-cta-was]');
    var savingsEl = root.querySelector('[data-kenos-savings]');
    var savingsRowsNow = root.querySelectorAll('[data-kenos-savings-now]');
    var savingsRowsWas = root.querySelectorAll('[data-kenos-savings-was]');
    var savingsAmountEl = root.querySelector('[data-kenos-savings-amount]');
    var savingsPctEl = root.querySelector('[data-kenos-savings-pct]');
    var savingsUrgencyWas = root.querySelector('[data-kenos-urgency-was]');

    var variantId = root.getAttribute('data-variant-id');
    var productId = root.getAttribute('data-product-id');
    var attribution = root.getAttribute('data-attribution') || 'lp_kenos';
    var currency = root.getAttribute('data-currency') || 'CLP';
    var basePrice = parseFloat(root.getAttribute('data-base-price')) || 0;
    var comparePrice = parseFloat(root.getAttribute('data-compare-price')) || 0;

    var section = root.closest('[data-kenos-section]');
    var bottleStack = section ? section.querySelector('[data-kenos-bottle-stack]') : null;

    // Tiers from the pack cards: { qty, code, pct }, ascending by qty.
    var tiers = packs.map(function (card) {
      return {
        qty: parseInt(card.getAttribute('data-pack-qty'), 10) || 1,
        code: (card.getAttribute('data-pack-discount') || '').trim(),
        pct: parseFloat(card.getAttribute('data-pack-discount-pct')) || 0,
      };
    }).sort(function (a, b) { return a.qty - b.qty; });

    var minQty = tiers.length ? tiers[0].qty : 1;

    // Highest tier whose qty <= n (so 4 -> the "3" tier, 6 -> the "5" tier).
    var tierFor = function (n) {
      var t = tiers[0] || { qty: 1, code: '', pct: 0 };
      for (var i = 0; i < tiers.length; i++) {
        if (tiers[i].qty <= n) { t = tiers[i]; }
      }
      return t;
    };

    // Current quantity of frascos. Start from the default-selected card (or first).
    var q = minQty;
    var initCard = root.querySelector('.k-pack-card.selected') || packs[0];
    if (initCard) { q = parseInt(initCard.getAttribute('data-pack-qty'), 10) || minQty; }

    var render = function () {
      var tier = tierFor(q);
      var price = tierPrice(basePrice, q, tier.pct);
      var was = Math.round(comparePrice) * q;
      var savings = was - price;
      var pct = was > 0 ? Math.round((1 - price / was) * 100) : 0;

      // Highlight the exact-match card only; none if no card has this qty.
      packs.forEach(function (card) {
        var on = (parseInt(card.getAttribute('data-pack-qty'), 10) || 0) === q;
        card.classList.toggle('selected', on);
        card.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      if (qtyValEl) qtyValEl.textContent = String(q);
      if (ctaPrice) ctaPrice.textContent = fmtCLP(price);
      if (ctaWas) ctaWas.textContent = fmtCLP(was);
      Array.prototype.forEach.call(savingsRowsNow, function (n) { n.textContent = fmtCLP(price); });
      Array.prototype.forEach.call(savingsRowsWas, function (n) { n.textContent = fmtCLP(was); });
      if (savingsAmountEl) savingsAmountEl.textContent = '−' + fmtCLP(savings);
      if (savingsPctEl) savingsPctEl.textContent = '(' + pct + '% OFF)';
      if (savingsUrgencyWas) savingsUrgencyWas.textContent = fmtCLP(was);
      if (savingsEl) savingsEl.style.display = savings > 0 ? '' : 'none';

      // Ficha/bottle image follows the applicable tier qty (1/2/3/5).
      if (bottleStack) bottleStack.setAttribute('data-count', String(tier.qty));
    };

    var setQty = function (n) {
      q = Math.max(minQty, n);
      render();
    };

    packs.forEach(function (card) {
      var cardQty = parseInt(card.getAttribute('data-pack-qty'), 10) || minQty;
      card.addEventListener('click', function () { setQty(cardQty); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setQty(cardQty);
        }
      });
    });

    if (qtyMinusBtn) qtyMinusBtn.addEventListener('click', function () { setQty(q - 1); });
    if (qtyPlusBtn) qtyPlusBtn.addEventListener('click', function () { setQty(q + 1); });

    render();

    // CTA: fire pixel events then redirect to /cart/<vid>:<q> with the matching code.
    var goToCart = function () {
      if (!variantId) return;
      var tier = tierFor(q);
      var price = tierPrice(basePrice, q, tier.pct);
      var pixelParams = {
        content_ids: [String(productId || variantId)],
        content_type: 'product',
        contents: [{ id: String(variantId), quantity: q }],
        value: price,
        currency: currency,
      };
      firePixel('AddToCart', pixelParams, uuidv4());
      var url = '/cart/' + variantId + ':' + q + '?attribution=' + encodeURIComponent(attribution);
      if (tier.code) {
        url += '&discount=' + encodeURIComponent(tier.code);
      }
      // Agrega al carrito y abre el drawer lateral (no navega a /cart). Fallback: permalink.
      if (window.KenosCart) {
        window.KenosCart.add([{ id: variantId, quantity: q }], tier.code || '');
      } else {
        window.location.href = url;
      }
    };

    if (ctaBtn) ctaBtn.addEventListener('click', function (e) {
      e.preventDefault();
      goToCart();
    });

    // Hero CTAs (smooth scroll to buy section)
    document.querySelectorAll('[data-kenos-buy-scroll]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.getElementById('kenos-buy');
        if (!target) return;
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  };

  // ---- FAQ accordion --------------------------------------------
  var initFAQ = function () {
    var items = document.querySelectorAll('.kenos-page .k-faq-item');
    items.forEach(function (item, idx) {
      var btn = item.querySelector('.k-faq-q');
      if (!btn) return;
      // Open first by default
      if (idx === 0) item.classList.add('k-open');
      btn.addEventListener('click', function () {
        var willOpen = !item.classList.contains('k-open');
        items.forEach(function (i) { i.classList.remove('k-open'); });
        if (willOpen) item.classList.add('k-open');
      });
    });
  };

  // ---- Countdown ------------------------------------------------
  var initCountdown = function () {
    var nodes = document.querySelectorAll('[data-kenos-countdown]');
    if (!nodes.length) return;
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var now = new Date();
      var end = new Date(now);
      end.setHours(23, 59, 59, 999);
      var diff = Math.max(0, end - now);
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      nodes.forEach(function (root) {
        var hEl = root.querySelector('[data-kenos-cd-h]');
        var mEl = root.querySelector('[data-kenos-cd-m]');
        var sEl = root.querySelector('[data-kenos-cd-s]');
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      });
    };
    tick();
    setInterval(tick, 1000);
  };

  // ---- Scroll reveal --------------------------------------------
  var initReveal = function () {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-kreveal], [data-kreveal-children]').forEach(function (el) {
        el.classList.add('k-revealed');
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('k-revealed');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('[data-kreveal], [data-kreveal-children]').forEach(function (el) {
      io.observe(el);
    });
  };

  // ---- Mobile sticky CTA ----------------------------------------
  var initSticky = function () {
    var bar = document.querySelector('[data-kenos-sticky]');
    if (!bar) return;
    var buy = document.getElementById('kenos-buy');
    var update = function () {
      if (!buy) return;
      var rect = buy.getBoundingClientRect();
      var inBuy = rect.top < window.innerHeight * 0.5 && rect.bottom > 200;
      var show = window.scrollY > 600 && !inBuy;
      bar.classList.toggle('k-show', show);
      document.body.classList.toggle('kenos-sticky-active', show);
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  // ---- Boot -----------------------------------------------------
  var boot = function () {
    document.querySelectorAll('[data-kenos-buy-panel]').forEach(initBuyPanel);
    initFAQ();
    initCountdown();
    initReveal();
    initSticky();
    // OJO: ViewContent/PageView/Purchase los dispara el canal nativo de Shopify
    // (Customer Events). AddToCart se dispara ADEMAS aca arriba en goToCart(),
    // con un eventID aleatorio que Meta NO puede deduplicar contra el del canal
    // nativo. Revisar en Events Manager si AddToCart llega duplicado y, si es
    // asi, borrar la linea firePixel('AddToCart', ...) de goToCart().
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Expose helper for manual events (e.g. from Shopify editor)
  window.kenosFmt = fmtCLP;
})();